// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.
import axios from 'axios'

import {verifySessionToken} from './user'
import {checkUserActivity} from './areYouThere'
import {VERSION_CHECKER_TTL} from '../config'

export const GET_BUILD_ID = 'get_build_id'
export const CHECK_UPDATE = 'update_available'
export const UPDATE_AVAILABLE = 'update_available'
export const SET_MESSAGE_SHOWN = 'set_message_shown'
export const UPDATE_DATE_NOW = 'update_date_now'

let timeKeeper = null

function timeKeeperRound (dispatch /* , getState*/) {
  /* TODO: ADD time keepers to fetch thinks periodicaly*/
  dispatch(verifySessionToken())
  dispatch(checkUserActivity())
  dispatch(checkAvailableUpdate())
  dispatch(updateDateNow())
}

export function startApp () {
  return (dispatch, getState) => {
    timeKeeperRound(dispatch, getState)

    if (!timeKeeper) {
      timeKeeper = setInterval(() => {
        timeKeeperRound(dispatch, getState)
      }, 1000)
    }
  }
}

export function getBuildId () {
  let date = new Date()
  return (dispatch) => {
    return axios.get(`/build-version.json?search=${date}`, {headers: {'Content-Type': 'json'}}).then(data => {
      dispatch({
        type: GET_BUILD_ID,
        payload: data.data
      })
    })
  }
}

export function checkAvailableUpdate () {
  return (dispatch, getState) => {
    const {update, timeKeeper} = getState()
    const elapsed = new Date() - timeKeeper.lastUpdateCheck
    if (elapsed > VERSION_CHECKER_TTL) {
      dispatch({
        type: CHECK_UPDATE
      })
      if (!update.updateAvailable && !update.declinedUpdate) {
        let date = new Date()
        return axios.get(`/build-version.json?search=${date}`, {headers: {'Content-Type': 'json'}}).then(data => {
          const {build_date} = data.data
          const {buildId} = getState().buildId
          if (build_date && buildId) {
            let updateDate = new Date(build_date * 1000)
            let actualVersionDate = new Date(buildId.build_date * 1000)
            if (updateDate > actualVersionDate) {
              dispatch({
                type: UPDATE_AVAILABLE,
                payload: true
              })
            }
          }
        })
      }
    }
  }
}

export function setUpdateMessageAsShown () {
  return (dispatch) => {
    return dispatch({
      type: SET_MESSAGE_SHOWN,
      payload: true
    })
  }
}

export function updateDateNow () {
  return (dispatch, getState) => {
    const {timeKeeper: {dateNow}} = getState()
    const elapsed = new Date() - (dateNow ? dateNow : 0)
    const timeLimit = 30 * 1000 // 30seg.
    if (elapsed > timeLimit) {
      // dispatch({
      //   type: UPDATE_DATE_NOW
      // })
    }
  }
}
